var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"overviewChart"}),_c('v-col',{attrs:{"md":"6"}},[_c('v-select',{attrs:{"value":_vm.dataType,"items":_vm.itemsFilters,"label":_vm.$t('commons.filters'),"outlined":""},on:{"change":_vm.onSelectChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }